var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('a',{staticClass:"az-action-link-icon",attrs:{"slot":"activator","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('download')}},slot:"activator"},[_c('i',{staticClass:"fas fa-download",attrs:{"aria-hidden":"true"}})]),_vm._v("\n    Download\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }